/* eslint-disable  react-hooks/exhaustive-deps */
import React, { FunctionComponent, useState } from "react";
import { omit, trim } from "lodash";

import { Button, Classes, Dialog, Intent } from "@blueprintjs/core";

import { ModelInstance } from "../../types/models";
import TransferModelInstanceForm, {
  Form,
  Fields,
  Errors,
} from "../organisms/TransferModelInstanceForm";

interface Props {
  instance: ModelInstance;
  isOpen: boolean;
  onClose(): void;
  onSave(fields: Fields): void;
}

function normalize(fields: Fields) {
  return {
    ...fields,
    Name: trim(fields.Name),
  };
}

function validate(values: Fields) {
  const errors: Errors = {};

  if (typeof values.Name !== "string" || values.Name === "") {
    errors.Name = "Please enter a name";
  }
  return errors;
}

const TransferModelInstanceDialog: FunctionComponent<Props> = ({
  instance,
  isOpen,
  onClose,
  onSave,
}) => {
  const getInitialForm = () => ({
    fields: {
      Name: `${instance.Name} Transfer`,
    },
    errors: {},
    disabled: false,
  });

  const [form, setForm] = useState<Form>(getInitialForm);
  const handleChange = (changes: Partial<Fields>) =>
    setForm({
      ...form,
      fields: { ...form.fields, ...changes },
      errors: omit(form.errors, Object.keys(changes)),
    });

  const handleSave = async () => {
    const values = normalize(form.fields);
    const errors = validate(values);

    if (Object.keys(errors).length > 0) {
      setForm({ ...form, errors });
      return;
    }

    try {
      try {
        setForm({ ...form, disabled: true });
        await onSave(form.fields);
      } finally {
        setForm({ ...form, disabled: false });
      }

      onClose();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Dialog
      title="Transfer Model Instance"
      isOpen={isOpen}
      onOpening={() => setForm(getInitialForm())}
      onClosed={() => setForm(getInitialForm())}
      onClose={onClose}
    >
      <div className={Classes.DIALOG_BODY}>
        <TransferModelInstanceForm
          {...form}
          instance={instance}
          onChange={handleChange}
        />
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button text="Cancel" onClick={onClose} />
          <Button
            text="Transfer Instance"
            intent={Intent.PRIMARY}
            disabled={form.disabled || !form.fields.Model}
            loading={form.disabled}
            onClick={handleSave}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default TransferModelInstanceDialog;
